import React, { useEffect, useState } from "react";

const BreathingBubble = () => {
    const [inhale, setInhale] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setInhale(prev => !prev);
        }, 4000); // 4s inhale, 4s exhale

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="text-center mt-10">
            <div className="breathing-bubble mx-auto" />
            <p className="mt-6 text-gray-700 text-lg">
                {inhale ? "Breathe out gently…" : "Breathe in slowly…"}
            </p>
        </div>
    );
};

export default BreathingBubble;